import React from 'react';
import PropTypes from 'prop-types';

import {withStyles} from '@material-ui/core/styles';
import _ from "lodash";
import ConnectionCard from "../../components/ConnectionCard";
import {connect} from "react-redux";
import {getConnectionsForUser} from "../../actions/session";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import ViewTitle from "../../components/ViewTitle";

const styles = theme => ({
  paper: {
    maxWidth: 936,
    margin: 'auto',
    overflow: 'hidden',
  },
  searchBar: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  },
  searchInput: {
    fontSize: theme.typography.fontSize,
  },
  block: {
    display: 'block',
  },
  addUser: {
    marginRight: theme.spacing(1),
  },
  contentWrapper: {
    margin: '40px 16px',
  },
});

let Profile = (props) => {
  const {classes, session} = props;

  const renderCards = (connections) => {
    if (!_.isEmpty(connections)) {
      return connections.map(conn => {
        return <ConnectionCard key={conn._id} connection={conn}/>
      })
    } else {
      return null
    }
  };

  return (
    <Paper className={classes.paper}>
      <div className={classes.contentWrapper}>
        <ViewTitle>
          Profile
        </ViewTitle>
        {_.isEmpty(session.userConnections) ?
          <React.Fragment>
                <Typography>
                  Once you have searched the database and made a few selections your results will show up here.
                </Typography>
          </React.Fragment>
          :
          renderCards(session.userConnections)
        }
      </div>
    </Paper>
  );
}


Profile.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStatetoProps = (state) => {
  return {
    ...state
  }
};

Profile = connect(
  mapStatetoProps, {
    getConnectionsForUser
  }
)(Profile);

export default withStyles(styles)(Profile);
